// extracted by mini-css-extract-plugin
export default {"container":"YB-z","vocBtn":"ZB-z","disabled":"_B-z"};